"use client";

import React from "react";
import { Plus } from "lucide-react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const faqs = [{
  question: "Is a deposit required to confirm my booking?",
  answer: "To secure your date at Ubud Event Space, we require a 50% non-refundable deposit. The remaining balance and final guest count are due 14 days before your event to ensure everything is perfectly prepared for your arrival."
}, {
  question: "Can we bring in external catering or vendors?",
  answer: "We offer flexible food packages including Balinese set menus and international buffets. You are welcome to bring external caterers for a standard corkage fee, provided they meet our health and safety standards."
}, {
  question: "What are the music and noise regulations?",
  answer: "To respect the tranquility of the surrounding Peliatan rice fields, amplified music is permitted until 10:00 PM. We request that volume levels remain within reasonable limits throughout the day to maintain our harmony with the local community."
}, {
  question: "Is there dedicated parking for my guests?",
  answer: "Yes, one of our primary advantages is our ample parking space for both cars and motorbikes. This is a rare feature for central Ubud locations, ensuring a smooth and stress-free arrival for all your attendees."
}, {
  question: "Do you provide decor and event equipment?",
  answer: "Our venue includes high-quality basic furniture and ambient lighting that complements our bamboo architecture. For themed decorations or specialized AV equipment, we can connect you with our trusted local event partners."
}];
export default function CommonCuriosities() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="119554" id="frequently-asked" className="bg-background py-20 md:py-32 px-6">
      <div ref={ref} className={`max-w-[800px] mx-auto transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-serif text-primary tracking-tight mb-6">
            Frequently Asked
          </h2>
          <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
            Plan your gathering with ease. Here are the most common inquiries regarding our venue policies, catering, and logistics in Peliatan, Ubud.
          </p>
        </div>

        <Accordion type="single" collapsible className="w-full">
          {faqs.map((faq, i) => <AccordionItem key={i} value={`item-${i}`} data-index={i} className="border-b border-border/60 py-2">
              <AccordionTrigger className="text-left text-lg md:text-xl font-medium text-foreground hover:no-underline hover:text-secondary transition-colors [&>svg:last-child]:hidden [&[data-state=open]_.custom-plus]:rotate-45 [&[data-state=open]_.custom-plus]:text-secondary py-6 group">
                <span className="pr-8">{faq.question}</span>
                <Plus className="custom-plus size-6 shrink-0 text-muted-foreground transition-transform duration-300 ease-in-out group-hover:text-secondary" />
              </AccordionTrigger>
              <AccordionContent className="text-muted-foreground text-base md:text-lg leading-relaxed pb-8 pr-12">
                {faq.answer}
              </AccordionContent>
            </AccordionItem>)}
        </Accordion>
      </div>
    </section>;
}